import {post,fetch,patch,put} from '../config/http'
import {baseUrl} from '../config/env'


/**
 * 获取微信配置信息
 */
export const getWxConfig = ( url ) => {
    return fetch( baseUrl + '/Api/index/getWxSign', {
        url: url,
    });
}

export const getInfoById = (xuanjiao_id , yiyuan_id) => {
    return fetch( baseUrl + '/xuanjiao/v1/xuanjiao/getInfoById', {
        xuanjiao_id: xuanjiao_id,
        yiyuan_id:yiyuan_id
    });
}

export const getList = (open_id) => {
    return fetch( baseUrl + '/xuanjiao/v1/xuanjiao/getList', {
        open_id: open_id
    });
}


export const addQianming = (xuanjiao_id , patient_or_principal_sign , edu_object , yiyuan_id) => {
    return post( baseUrl + '/xuanjiao/v1/xuanjiao/addQianming', {
        xuanjiao_id: xuanjiao_id,
        edu_object:edu_object,
        patient_or_principal_sign:patient_or_principal_sign,
        yiyuan_id:yiyuan_id
    });
}


